export default __webpack_public_path__ + "9a315ba26b7c3ecb15023c223842851c.png";